import React, { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { createAdmin } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";

const INIT_STATE = {
    csvFile: "",
};

export default function ImportEmployees() {
    const [state, setState] = useState(INIT_STATE);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
            type: "inhouse"
        };
        if(data.name){
            setLoading(true);
            createAdmin(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                    console.log(res.data.message);
                } else {
                    alertError(res.data.message)
                    console.log(res.data.message)
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err.response)
                alertError(err.response?.data?.error);
                setLoading(false);
            });
        }
    };
    
    return (
        <>
            <h1 className="dash-title"><Link to="/hiring" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Import Employees</div>
                            {/* <div className="spur-card-menu"><a href="#/" download className="btn btn-primary myybtn">DOWNLOAD TEMPLATE</a></div> */}
                        </div>
                        <div className="card-body">
                            <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-5 form-group">
                                        <label className="control-label"> CSV File <span>*</span></label>
                                        <input type="file" name="file" className="form-control" placeholder="CSV file" required 
                                            onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4 form-group">
                                        <label className="control-label">&nbsp;</label>
                                        <button 
                                            type="submit" 
                                            disabled={loading} 
                                            // disabled
                                            className="btn btn-primary" 
                                            name="bulk_add_staff"
                                        >
                                            UPLOAD DATA
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
